import { Component, Input, OnChanges } from '@angular/core';
import {
  mapOverviewBreakdownItems,
  mapOverviewFundingItems,
  overviewStatItems,
  timelinessPercentSegments,
  tripStatusSegments
} from '../../utils/chart-helpers';
import { CHART_COLORS } from '../../utils/chart-theme';

@Component({
  selector: 'app-br-overview-tab',
  templateUrl: './overview-tab.component.html'
})
export class BrOverviewTabComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() error: string;
  @Input() data: any;

  readonly chartColors = CHART_COLORS;

  fundingItems: any[] = [];
  spaceItems: any[] = [];
  losItems: any[] = [];
  timelinessItems: any[] = [];
  completionSegments: any[] = [];
  statItems: any[] = [];

  ngOnChanges() {
    if (!this.data) return;
    const kpiCards = this.data.kpiCards || {};
    const charts = this.data.charts || {};

    this.fundingItems = mapOverviewFundingItems(charts.fundingSource);
    this.spaceItems = mapOverviewBreakdownItems(charts.spaceType, 'spaceType');
    this.losItems = mapOverviewBreakdownItems(charts.los, 'los');
    this.timelinessItems = timelinessPercentSegments(charts.timeliness);
    this.completionSegments = tripStatusSegments(
      kpiCards.totalTrips,
      kpiCards.completedTrips,
      kpiCards.cancelledTrips
    );
    this.statItems = overviewStatItems(kpiCards);
  }

  pctFormatter = (v: number) => `${Math.round(v)}%`;

  losColors = [CHART_COLORS[1], CHART_COLORS[0], CHART_COLORS[4], CHART_COLORS[2]];
}
